import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export const FAMILY_PALETTE = { dark: "#A4462A", dark2: "#B9573A", accent: "#B7791F", cream: "#FFF9EF", paper: "#FCEFD8", mist: "#E2F0F7", ink: "#2B1D16", text_muted: "#8E7A6A", line: "#EBDCC4" };
export const FAMILY_PALETTE_NAME = "Terracotta, Sunflower & Sky";
let cache = null;
let pending = null;

export const useCountries = () => {
  const [list, setList] = useState(cache || []);
  useEffect(() => {
    if (cache) return;
    pending = pending || api.get("/countries").then((r) => (cache = r.data));
    pending.then(setList).catch(() => {});
  }, []);
  return list;
};

export const countryOf = (list, name) => list.find((c) => c.name === (name || "Italy")) || list[0];

export const CountryTag = ({ country, testId }) => {
  const c = countryOf(useCountries(), country);
  if (!c) return null;
  return (
    <span data-testid={testId} title={`${c.series} · ${c.palette_name}`} className="inline-flex items-center gap-1.5 text-[10px] uppercase tracking-wider px-2 py-0.5"
      style={{ background: c.palette.dark, color: c.palette.accent }}>
      <i className="w-1.5 h-1.5 rounded-full inline-block" style={{ background: c.palette.accent }} />{c.name}
    </span>
  );
};

export const CountrySelect = ({ value, onChange, testId, className = "" }) => {
  const list = useCountries();
  return (
    <select data-testid={testId} value={value} onChange={(e) => onChange(e.target.value)} className={`h-11 bg-white border border-input px-3 text-sm rounded-none ${className}`}>
      {list.map((c) => <option key={c.name} value={c.name}>{c.name} · {c.series}</option>)}
    </select>
  );
};
